"use client"
import { Modal, Button } from "react-bootstrap"
import BackgroundData from "../assets/defensa2.webp"

const ModalTratDatos = ({ showDataModal, setShowDataModal }) => {
    
  const styles = {
    modalBody: {
      background: `linear-gradient(rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), 
                  url(${BackgroundData}) center/cover no-repeat`,
      maxHeight: "70vh",
      overflowY: "auto",
      lineHeight: "1.6",
      fontSize: "14px",
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    },
    mainTitle: {
      textAlign: "center",
      marginBottom: "2rem",
      fontSize: "1.75rem",
      fontWeight: "700",
      color: "#5B726A",
      borderBottom: " #5B726A",
      paddingBottom: "1rem",
    },
    sectionTitle: {
      fontSize: "1.25rem",
      fontWeight: "600",
      color: "#5B726A",
      marginBottom: "1rem",
      borderBottom: "2px solid #ecf0f1",
      paddingBottom: "0.5rem",
      marginTop: "2rem",
    },
    subsectionTitle: {
      fontSize: "1.1rem",
      fontWeight: "600",
      color: "#5B726A",
      marginBottom: "0.75rem",
      marginTop: "1.5rem",
    },
    leadParagraph: {
      fontSize: "1.05rem",
      fontWeight: "400",
      color: "#5B726A",
      marginBottom: "1.5rem",
      lineHeight: "1.7",
    },
    paragraph: {
      marginBottom: "1rem",
      color: "#5B726A",
      textAlign: "justify",
    },
    definitionList: {
      listStyle: "none",
      paddingLeft: "0",
    },
    definitionItem: {
      marginBottom: "1rem",
      padding: "0.75rem",
      backgroundColor: "#f8f9fa",
      borderLeft: "4px solid #728B6D",
      borderRadius: "0 4px 4px 0",
      color: '#5B726A'
    },
    definitionTerm: {
      fontWeight: "600",
      color: "#5B726A",
      marginRight: "0.5rem",
    },
    regularList: {
      paddingLeft: "1.5rem",
      marginBottom: "1.5rem",
    },
    listItem: {
      marginBottom: "0.5rem",
      color: "#5B726A",
    },
    highlightBox: {
      backgroundColor: "#f7f7f7",
      border: "1px solid #f7f7f7",
      borderRadius: "6px",
      padding: "1rem",
      marginBottom: "1.5rem",
    },
    contactBox: {
      backgroundColor: "#f7f7f7",
      border: "1px solid #f7f7f7",
      borderRadius: "6px",
      padding: "1rem",
      marginBottom: "1rem",
    },
    strongText: {
      fontWeight: "600",
      color: "#5B726A",
    },
    processStep: {
      backgroundColor: "#fff",
      border: "1px solid #dee2e6",
      borderRadius: "4px",
      padding: "0.75rem",
      marginBottom: "0.5rem",
      borderLeft: "4px solid #728B6D",
      color: '#5B726A'
    },
    section: {
      marginBottom: "2.5rem",
    },
  }

  return (
    <>
     

      <Modal show={showDataModal} onHide={() => setShowDataModal(false)} dialogClassName="modal-data" size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Política de Protección y Privacidad de Datos Personales</Modal.Title>
        </Modal.Header>

        <Modal.Body style={styles.modalBody}>
          <div className="principal fade-in">
            <div className="container">
              {/* Título principal */}
              <h1 style={styles.mainTitle} >
                Política de Tratamiento de Datos en Colombia
              </h1>

              {/* Introducción */}
              <section style={styles.section}>
                <p style={styles.leadParagraph}>
                  Con el fin de garantizar y proteger el derecho constitucional que todas las personas tienen a conocer,
                  actualizar, rectificar y suprimir sus datos personales almacenados en bases de datos, se pone a
                  disposición de los titulares de los datos personales la presente política para el uso, administración,
                  transmisión y demás actividades relacionadas con el tratamiento de datos personales.
                </p>
                <p style={styles.paragraph}>
                  La Sociedad se compromete a proteger la privacidad y la confidencialidad de la información, de acuerdo
                  con la Constitución, la Ley 1581 de 2012, el Decreto 1377 de 2013, el Decreto 1081 de 2015, el Decreto
                  255 de 2022 y demás normativas vigentes.
                </p>
              </section>

              {/* Sección 2: Alcance */}
              <section style={styles.section}>
                <h2 style={styles.sectionTitle} className="section-title">
                  2. Alcance
                </h2>
                <p style={styles.paragraph}>
                  Sus datos personales son necesarios para que la sociedad pueda brindarle un servicio integral. Por
                  ello, le informamos que los datos personales que usted nos suministre o a los que la sociedad tenga
                  acceso en el desarrollo del objeto contractual serán tratados conforme a lo dispuesto en la Política
                  de Tratamiento de Datos Personales.
                </p>
                <p style={styles.paragraph}>
                  Esta política aplica a todas las operaciones y actividades que involucren el tratamiento de datos
                  personales realizados por DYD ASESORÍAS S.A.S, así como a todos los empleados, contratistas y terceros
                  que manejen información personal en nombre de la empresa.
                </p>
              </section>

              {/* Sección 3: Definiciones */}
              <section style={styles.section}>
                <h2 style={styles.sectionTitle} className="section-title">
                  3. Definiciones
                </h2>
                <p style={styles.paragraph}>
                  En el desarrollo, interpretación y aplicación de la ley, regulaciones y normatividad vigente, se
                  aplicarán de manera armónica e integral las siguientes definiciones:
                </p>
                <ul style={styles.definitionList}>
                  <li style={styles.definitionItem} className="definition-item">
                    <span style={styles.definitionTerm}>Autorización:</span>
                    Es el consentimiento previo, expreso e informado del Titular para llevar a cabo el Tratamiento de
                    sus Datos Personales.
                  </li>
                  <li style={styles.definitionItem} className="definition-item">
                    <span style={styles.definitionTerm}>Base de Datos:</span>
                    Conjunto organizado de Datos Personales objeto de Tratamiento, electrónico o no, cualquiera que
                    fuere la modalidad de su formación, almacenamiento, organización y acceso.
                  </li>
                  <li style={styles.definitionItem} className="definition-item">
                    <span style={styles.definitionTerm}>Dato Financiero:</span>
                    Información relacionada con obligaciones dinerarias, independientemente de la naturaleza del
                    contrato que les dé origen.
                  </li>
                  <li style={styles.definitionItem} className="definition-item">
                    <span style={styles.definitionTerm}>Dato Personal:</span>
                    Información vinculada o que pueda asociarse a una o varias personas naturales o jurídicas
                    determinadas o determinables.
                  </li>
                  <li style={styles.definitionItem} className="definition-item">
                    <span style={styles.definitionTerm}>Dato Público:</span>
                    Dato Personal calificado como tal según la ley o la Constitución Política, y que no es semiprivado,
                    privado o sensible.
                  </li>
                  <li style={styles.definitionItem} className="definition-item">
                    <span style={styles.definitionTerm}>Dato Sensible:</span>
                    Información que afecta la intimidad del Titular o cuyo uso indebido puede generar discriminación.
                  </li>
                  <li style={styles.definitionItem} className="definition-item">
                    <span style={styles.definitionTerm}>Encargado del Tratamiento:</span>
                    Persona natural o jurídica que realice el Tratamiento de Datos Personales por cuenta del Responsable
                    del Tratamiento.
                  </li>
                  <li style={styles.definitionItem} className="definition-item">
                    <span style={styles.definitionTerm}>Responsable de Tratamiento:</span>
                    Persona que decida sobre la Base de Datos y/o el Tratamiento de los Datos Personales.
                  </li>
                  <li style={styles.definitionItem} className="definition-item">
                    <span style={styles.definitionTerm}>Titular:</span>
                    Persona natural cuyos Datos Personales sean objeto de Tratamiento.
                  </li>
                </ul>
              </section>

              {/* Sección 4: Principios */}
              <section style={styles.section}>
                <h2 style={styles.sectionTitle} className="section-title">
                  4. Principios
                </h2>
                <p style={styles.paragraph}>
                  El tratamiento de datos personales en DYD ASESORÍAS S.A.S se rige por los siguientes principios:
                </p>
                <ul style={styles.regularList}>
                  <li style={styles.listItem}>
                    <span style={styles.strongText}>Limitación de la finalidad:</span> Los datos se recopilan para fines
                    específicos, explícitos y legítimos.
                  </li>
                  <li style={styles.listItem}>
                    <span style={styles.strongText}>Minimización de datos:</span> Solo se recopilan los datos necesarios
                    para el cumplimiento de la labor encomendada.
                  </li>
                  <li style={styles.listItem}>
                    <span style={styles.strongText}>Exactitud:</span> Los datos personales deben ser precisos y
                    mantenerse actualizados.
                  </li>
                  <li style={styles.listItem}>
                    <span style={styles.strongText}>Limitación del plazo de conservación:</span> Los datos se
                    conservarán solo durante el tiempo necesario para cumplir con los fines.
                  </li>
                  <li style={styles.listItem}>
                    <span style={styles.strongText}>Integridad y confidencialidad:</span> Los datos serán tratados con
                    medidas de seguridad adecuadas.
                  </li>
                </ul>
              </section>

              {/* Sección 5: Tratamiento de Datos Personales */}
              <section style={styles.section}>
                <h2 style={styles.sectionTitle} className="section-title">
                  5. Tratamiento de Datos Personales
                </h2>
                <p style={styles.paragraph}>Los Datos Personales serán tratados para las siguientes finalidades:</p>
                <ul style={styles.regularList}>
                  <li style={styles.listItem}>
                    Gestionar información necesaria para el cumplimiento de las obligaciones de la Sociedad.
                  </li>
                  <li style={styles.listItem}>
                    Prestar servicios conforme a las necesidades particulares de los clientes.
                  </li>
                  <li style={styles.listItem}>
                    Controlar y prevenir actividades ilícitas como fraude, lavado de activos, etc.
                  </li>
                  <li style={styles.listItem}>Permitir el acceso a datos personales a auditores o terceros.</li>
                  <li style={styles.listItem}>
                    Gestionar el archivo, actualización de sistemas y protección de la información.
                  </li>
                  <li style={styles.listItem}>Transmitir datos a terceros con quienes se hayan celebrado contratos.</li>
                </ul>

                {/* Subsección 5.1 */}
                <h3 style={styles.subsectionTitle}>
                  5.1 Tratamiento de Datos Personales de Niñas, Niños y Adolescentes
                </h3>
                <p style={styles.paragraph}>
                  La sociedad Tratará los Datos Personales de un menor de 18 años, siempre que exista el consentimiento
                  previo y expreso de padres o tutores legales. En estos casos, los padres o tutores legales pueden
                  cambiar o revocar la Autorización tal como se describe en esta Política. Adicionalmente, el
                  Tratamiento de los Datos Personales de niñas, niños y adolescentes, cumplirá con los siguientes
                  parámetros y requisitos:
                </p>
                <ul style={styles.regularList}>
                  <li style={styles.listItem}>
                    El Tratamiento responderá y respetará el interés superior de los niños, niñas y adolescentes.
                  </li>
                  <li style={styles.listItem}>
                    En todo momento se asegurará el respeto de sus derechos fundamentales.
                  </li>
                  <li style={styles.listItem}>
                    El niño, niña o adolescente será escuchado, y su opinión será valorada teniendo en cuenta la
                    madurez, autonomía y capacidad para entender el asunto.
                  </li>
                </ul>

                {/* Subsección 5.2 */}
                <h3 style={styles.subsectionTitle}>5.2 Tratamiento de Datos Sensibles</h3>
                <p style={styles.paragraph}>
                  La sociedad podrá solicitar los Datos Sensibles que expresamente se mencionarán en cada Autorización.
                  En todo caso, la sociedad observará estrictamente las limitaciones legales al Tratamiento de Datos
                  Sensibles, sometiendo a Tratamiento los Datos Sensibles únicamente cuando el Titular haya otorgado su
                  Autorización, salvo en los casos en que la ley no requiera de dicha Autorización. Cuando la sociedad
                  solicite Datos Sensibles, le informará qué tipo de Datos Personales tienen esta categoría y no
                  condicionará, en ningún caso, ninguna actividad a la entrega de Datos Sensibles.
                </p>
              </section>

              {/* Sección 6: Derechos del Titular */}
              <section style={styles.section}>
                <h2 style={styles.sectionTitle} className="section-title">
                  6. Derechos del Titular de los Datos Personales
                </h2>
                <p style={styles.paragraph}>
                  De acuerdo con la ley, los Titulares de Datos Personales tienen los siguientes derechos:
                </p>
                <ul style={styles.definitionList}>
                  <li style={styles.definitionItem} className="definition-item">
                    <span style={styles.definitionTerm}>Actualización:</span>
                    Conocer, actualizar y rectificar sus datos personales frente a la Sociedad o los Encargados del
                    Tratamiento.
                  </li>
                  <li style={styles.definitionItem} className="definition-item">
                    <span style={styles.definitionTerm}>Prueba:</span>
                    Solicitar prueba de la autorización otorgada a la Sociedad, salvo cuando no sea necesaria.
                  </li>
                  <li style={styles.definitionItem} className="definition-item">
                    <span style={styles.definitionTerm}>Información:</span>
                    Solicitar a la Sociedad o al Encargado del Tratamiento información sobre el uso que se ha dado a sus
                    datos personales.
                  </li>
                  <li style={styles.definitionItem} className="definition-item">
                    <span style={styles.definitionTerm}>Quejas y Reclamos:</span>
                    Presentar quejas ante la Superintendencia de Industria y Comercio por infracciones a la ley.
                  </li>
                  <li style={styles.definitionItem} className="definition-item">
                    <span style={styles.definitionTerm}>Revocación:</span>
                    Revocar la autorización otorgada y solicitar la eliminación de sus datos personales de las bases de
                    datos.
                  </li>
                  <li style={styles.definitionItem} className="definition-item">
                    <span style={styles.definitionTerm}>Acceso:</span>
                    Acceder de manera gratuita a los datos personales que han sido objeto de tratamiento.
                  </li>
                </ul>
              </section>

              {/* Sección 8: Peticiones y Reclamos */}
              <section style={styles.section}>
                <h2 style={styles.sectionTitle} className="section-title">
                  8. Peticiones, Consultas y Reclamos
                </h2>

                <h3 style={styles.subsectionTitle}>Consultas</h3>
                <p style={styles.paragraph}>
                  La sociedad dispondrá de mecanismos para que el Titular, sus causahabientes, o los representantes de
                  menores de edad Titulares, formulen consultas respecto de cuáles son los Datos Personales del Titular
                  que reposan en las Bases de Datos de la sociedad.
                </p>

                <div style={styles.highlightBox}>
                  <h4 style={{ ...styles.subsectionTitle, marginTop: "0", fontSize: "1rem" }}>Canales de Atención:</h4>
                  <ul style={styles.regularList}>
                    <li style={styles.listItem}>
                      <span style={styles.strongText}>Físico:</span> Carrera 27 A No. 66-30 Oficina 1005 C.C Sancancio,
                      Manizales
                    </li>
                    <li style={styles.listItem}>
                      <span style={styles.strongText}>Teléfono:</span> 8911707
                    </li>
                    <li style={styles.listItem}>
                      <span style={styles.strongText}>Electrónico:</span> A través del correo electrónico
                    </li>
                  </ul>
                </div>

                <h4 style={{ ...styles.subsectionTitle, fontSize: "1rem" }}>Proceso para Consultas:</h4>
                <ol style={styles.regularList}>
                  <li style={styles.processStep}>Las solicitudes se deberán formular por escrito.</li>
                  <li style={styles.processStep}>
                    La solicitud será analizada para verificar la identificación del Titular.
                  </li>
                  <li style={styles.processStep}>
                    Respuesta dentro de los <span style={styles.strongText}>10 días hábiles</span> contados a partir de
                    la fecha de recepción.
                  </li>
                  <li style={styles.processStep}>
                    La respuesta definitiva no tardará más de <span style={styles.strongText}>15 días hábiles</span>{" "}
                    desde la fecha inicial.
                  </li>
                </ol>
              </section>

              {/* Sección 13: Contacto */}
              <section style={styles.section}>
                <h2 style={styles.sectionTitle} className="section-title">
                  13. Contacto
                </h2>
                <p style={styles.paragraph}>
                  Para cualquier consulta, solicitud o ejercicio de derechos en relación con sus datos personales, los
                  titulares pueden ponerse en contacto con el Delegado de Protección de Datos:
                </p>
                <div style={styles.contactBox}>
                  <ul style={{ ...styles.definitionList, marginBottom: "0" }}>
                    <li style={{ ...styles.listItem, marginBottom: "0.75rem" }}>
                      <span style={styles.strongText}>Dirección:</span> Carrera 27 A No. 66-30 Oficina 1005 C.C
                      Sancancio, Manizales
                    </li>
                    <li style={{ ...styles.listItem, marginBottom: "0" }}>
                      <span style={styles.strongText}>Teléfono:</span> 8911707
                    </li>
                  </ul>
                </div>
              </section>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDataModal(false)}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default ModalTratDatos
